import { Box, Button, HStack, Heading, Input, Spinner, Text, VStack } from '@chakra-ui/react';
import { HTTP } from '@utils/http';
import { useState } from 'react';
import { useNavigate } from 'react-router';

export function ResetPasswordForm() {
  const [email, setEmail] = useState<string>('');
  const [errorPwd, setErrorPwd] = useState<string>('');
  const [resetPwdConfirmation, setResetPwdConfirmation] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const navigate = useNavigate();

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    setIsLoading(true);
    event.preventDefault();
    try {
      // Effectuez la requête et obtenez la réponse complète
      const response = (await HTTP.post('/auth/resetPassword', { email }).send()) as any;

      if (response?.status === 200) {
        setResetPwdConfirmation(
          'Vous allez bientôt recevoir un email pour réinitialiser votre passe, pensez à checker vos emails indésirables',
        );
      } else {
        throw new Error('Une erreur inattendue est survenue');
      }
    } catch (error: any) {
      let errorMessage = 'Une erreur est survenue lors de la réinitialisation du mot de passe.';

      // Extrait directement l'ErrorCode de l'erreur, sans accéder à `response.data`
      const errorCode = error?.ErrorCode || error?.response?.data?.ErrorCode;

      // Vérifie les codes d'erreur connus et ajuste le message d'erreur en conséquence
      switch (errorCode) {
        case 'INVALID_EMAIL':
          errorMessage = "L'adresse email saisie est invalide. Veuillez vérifier et réessayer.";
          break;
        case 'USER_NOT_FOUND':
          errorMessage = 'Aucun utilisateur trouvé avec cette adresse email. Veuillez vérifier et réessayer.';
          break;
        // Ajoutez ici d'autres cas selon les ErrorCode que votre backend peut renvoyer
        default:
          // Si l'ErrorCode n'est pas reconnu, essaie d'afficher le message d'erreur standard renvoyé par le backend
          errorMessage = error?.Message || error?.response?.data?.Message || error?.message || errorMessage;
      }

      setErrorPwd(`${errorMessage}`);
      console.error(JSON.stringify(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box w="full">
      <HStack width="100%" justifyContent="space-between" margin="1em 0 2em">
        <Heading className="accountMainTitle" size="md" textTransform="uppercase">
          Réinitialiser le mot de passe
        </Heading>
        <Button variant="contained" onClick={() => navigate(-1)}>
          Retour
        </Button>
      </HStack>
      <VStack width="100%" margin="1em 0 2em">
        <form style={{ width: '40%' }} onSubmit={handleSubmit}>
          <HStack spacing={5}>
            <Input
              type="email"
              placeholder="Entrez votre email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button type="submit" variant="contained" width={'200px'}>
              {isLoading ? <Spinner color="white" alignContent="center" size="sm" /> : 'Reset'}
            </Button>
          </HStack>
        </form>
        <Text color="red">{errorPwd}</Text>
        <Text>{resetPwdConfirmation}</Text>
      </VStack>
    </Box>
  );
}
